import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Leaf, ArrowRight } from "lucide-react";
import { api } from "@/lib/api";

export const MyCedaLink = () => {
  const [info, setInfo] = useState(null);
  useEffect(() => {
    api.get("/ceda/me").then((r) => setInfo(r.data)).catch(() => setInfo(null));
  }, []);
  if (!info || (!info.module_active && info.items.length === 0)) return null;
  const count = (s) => info.items.filter((i) => i.status === s).length;
  return (
    <Link to="/mon-espace/ceda" data-testid="espace-ceda-link" className="mt-8 flex items-center gap-4 rounded-2xl bg-white border border-[#E8DCC4] p-5 hover:border-[#C9A24B]/60 transition-colors">
      <span className="w-11 h-11 rounded-full bg-[#C9A24B]/15 text-[#C9A24B] flex items-center justify-center"><Leaf size={20} /></span>
      <div className="flex-1">
        <p className="font-serif text-lg text-[#1F2A24]">Mes CEDA</p>
        <p className="font-sans text-xs text-[#1F2A24]/60">{info.items.length ? `${count("active")} en cours · ${count("pending")} en attente d'activation` : "Découvrez les capsules énergétiques"}</p>
      </div>
      <ArrowRight size={18} className="text-[#385E3A]" />
    </Link>
  );
};
